import React from 'react';

export const FIPFooter = () => {
  return (
    <footer className="bg-dark-blue text-white py-12">
      <div className="container-fip">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
{/* Logo */}
<div className="flex items-center gap-3">
  {/* Substitui o fundo colorido por uma imagem */}
  <div className="w-12 h-12 rounded-lg overflow-hidden flex items-center justify-center">
    <img
      src="./Certificado.png" // 👉 coloque aqui o caminho da sua imagem (ex: /images/logo.png)
      alt="Logo NBZ"
      className="w-full h-full object-cover"
    />
  </div>
  <div>
    <div className="text-white font-bold text-lg leading-tight">NBZ</div>
    <div className="text-white/80 text-sm leading-tight">Educação</div>
  </div>
</div>

          {/* Copyright */}
          <div className="text-center md:text-left">
            <p className="text-white/80">© 2025 NBZ Educação – Todos os direitos reservados</p>
          </div>
        </div>
      </div>
    </footer>
  );
};